/* eslint-disable require-jsdoc */
import axios from 'axios';
import url from './url';
import {getLocalData} from '@/lib/base/localData';
import ERRORS from '@/constant/errors';
import Message from '@/lib/base/message';
import getProvinceId from '@/lib/base/getProvinceId';

const apiErrorHandlers = [];

function onApiError(callback) {
  apiErrorHandlers.push(callback);
}

/**
 * 呼叫 API 函式，並可以將資料存在 APP 內(但是不包含讀取)
 * @param {String} category lambda的API類別
 * @param {String} apiName 該API的名稱
 * @param {Object} data 傳入該API的資料
 * @param {Object} method [post,get] API的方法等
 * @param {Object} headers request的header
 * @returns {Promise<Object>} API回傳結果
 */
async function callApi({
  category,
  apiName = '',
  data,
  params,
  headers = {},
  method,
  defaultError = null,
  timeout = 0,
}) {
  method = method.toLowerCase();
  const apiUrl = url.lambda[category] + apiName;
  let examJwt = null;
  const parts = document.cookie.split('examJwt=');
  examJwt = parts[1];
  const sendHeaders = Object.assign(headers, {
    Authorization: getLocalData('jwt'),
    Accept: 'application/json',
    ExamToken: `Bearer ${examJwt}`,
    ProvinceId: getProvinceId(),
  });

  // #endregion
  try {
    const res = await axios({
      method,
      url: apiUrl,
      data,
      params,
      headers: sendHeaders,
      timeout,
    });
    return res;
  } catch (apiError) {
    for (const handler of apiErrorHandlers) {
      handler(apiError, {category, apiName, data, params, headers, method});
    }
    if (defaultError !== null) {
      const errorText = ERRORS[apiError?.response?.data?.message];
      if (errorText) {
        Message.error(errorText);
      } else {
        Message.error(defaultError || '無法正常執行，請稍後再試。');
      }
    }

    return Promise.reject(apiError);
  }
}

export {callApi, onApiError};
